export const FETCH_AGGREGATE_RESULTS_REQUEST = 'FETCH_AGGREGATE_RESULTS_REQUEST';
export const FETCH_AGGREGATE_RESULTS_SUCCESS = 'FETCH_AGGREGATE_RESULTS_SUCCESS';
export const FETCH_AGGREGATE_RESULTS_FAILURE = 'FETCH_AGGREGATE_RESULTS_FAILURE';
